export default __webpack_public_path__ + "static/media/error_404.88683552.png";